(function () {
  document.querySelectorAll('[data-cz]').forEach(function (root) {
    // Galeria: strzałki, miniatury, zaznaczenie bieżącego zdjęcia
    var slides = root.querySelector('[data-cz-slides]');
    var thumbs = root.querySelectorAll('[data-cz-thumb]');
    var current = function () {
      var items = slides.children, best = 0, min = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - slides.offsetLeft - slides.scrollLeft - parseFloat(getComputedStyle(slides).paddingLeft));
        if (d < min) { min = d; best = i; }
      }
      return best;
    };
    var go = function (i) {
      var items = slides.children;
      i = Math.max(0, Math.min(items.length - 1, i));
      slides.scrollTo({ left: items[i].offsetLeft - slides.offsetLeft - parseFloat(getComputedStyle(slides).paddingLeft), behavior: 'smooth' });
    };
    if (slides) {
      var prev = root.querySelector('[data-cz-prev]'), next = root.querySelector('[data-cz-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.czThumb)); }); });
      slides.addEventListener('scroll', function () {
        var c = current();
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === c ? 'true' : 'false'); });
      }, { passive: true });
    }

    // Cena po wyborze zestawu
    root.querySelectorAll('input[data-cz-price]').forEach(function (r) {
      r.addEventListener('change', function () {
        root.querySelectorAll('[data-cz-price-out]').forEach(function (el) { el.textContent = r.dataset.czPrice; });
        // Pasek przyklejony: nazwa zestawu, rabat i przekreślona suma pojedynczych sztuk (puste przy 1 sztuce)
        var full = r.dataset.czFull || '', save = r.dataset.czSave || '';
        root.querySelectorAll('[data-cz-sticky-set]').forEach(function (el) { if (r.dataset.czName) el.textContent = r.dataset.czName; });
        root.querySelectorAll('[data-cz-sticky-save]').forEach(function (el) {
          el.hidden = !save;
          var out = el.querySelector('[data-cz-sticky-save-out]'); if (out) out.textContent = save;
        });
        root.querySelectorAll('[data-cz-sticky-full]').forEach(function (el) { el.hidden = !full; el.textContent = full; });
      });
    });

    // Wybór wersji do każdej sztuki zestawu: tyle pól, ile sztuk; ukryte pola są wyłączone, więc nie trafiają do koszyka.
    // Przy dwóch opcjach (zestaw + wersja) pierwsze pole wybiera wariant, kolejne idą jako właściwości pozycji.
    var pick = root.querySelector('[data-cz-pick]');
    if (pick) {
      var label = pick.dataset.czPickLabel;
      var main = pick.querySelector('[data-cz-pick-main]');
      var setQty = function (qty) {
        pick.querySelectorAll('[data-cz-pick-row]').forEach(function (row) {
          var n = Number(row.dataset.czPickRow), on = n <= qty;
          row.hidden = !on;
          row.querySelector('.cz-pick__label').hidden = qty === 1;
          // Pole wiersza: lista (select) albo kafelki ze zdjęciami (radio o tej samej nazwie); wyłączone pole nie trafia do koszyka
          row.querySelectorAll('select, input[type="radio"]').forEach(function (f) {
            if (f === main) return;
            f.disabled = !on;
            // rzędy od drugiego zawsze z numerem: wspólna nazwa łączyłaby radio w jedną grupę i kasowała zaznaczenie
            f.name = 'properties[' + label + (qty > 1 || main || n > 1 ? ' ' + n : '') + ']';
          });
        });
        // Rodzina kart: pierwsza sztuka to wersja z tej karty (ukryte pole), kolejne wybiera klient
        var first = pick.querySelector('[data-cz-pick-first]');
        if (first) first.name = 'properties[' + label + (qty > 1 ? ' 1' : '') + ']';
        pick.hidden = !pick.querySelector('[data-cz-pick-row]:not([hidden])');
        // Kwadraciki prowadzą do innej wersji z tym samym zestawem
        root.querySelectorAll('[data-cz-swatch]').forEach(function (a) {
          var ids = (a.dataset.ids || '').split(',');
          a.href = a.dataset.url + (qty > 1 && ids[qty - 1] ? '?variant=' + ids[qty - 1] : '');
        });
      };
      root.querySelectorAll('input[data-cz-qty]').forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) setQty(Number(r.dataset.czQty)); });
      });
      // Lista rozwijana ze zdjęciami: przycisk pokazuje wybraną wersję, panel z radio otwiera się pod nim.
      // Klik myszą wybiera i zamyka; strzałki zmieniają wybór bez zamykania, Enter i Escape zamykają; klik poza listą zamyka.
      pick.querySelectorAll('[data-cz-dd]').forEach(function (dd) {
        var btn = dd.querySelector('.cz-dd__btn'), list = dd.querySelector('.cz-dd__list'), cur = dd.querySelector('.cz-dd__cur');
        var open = function (on) {
          list.hidden = !on;
          dd.classList.toggle('is-open', on);
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (on) {
            var c = list.querySelector('input:checked') || list.querySelector('input');
            if (c) { c.focus({ preventScroll: true }); list.scrollTop = Math.max(0, c.closest('.cz-dd__opt').offsetTop - 6); }
          }
        };
        btn.addEventListener('click', function () { open(list.hidden); });
        list.querySelectorAll('input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            list.querySelectorAll('.cz-dd__opt').forEach(function (o) { o.classList.toggle('is-on', o.contains(inp)); });
            var im = inp.closest('.cz-dd__opt').querySelector('img'), name = document.createElement('span');
            name.textContent = inp.value;
            cur.textContent = '';
            if (im) { var copy = im.cloneNode(); copy.loading = 'eager'; cur.appendChild(copy); }
            cur.appendChild(name);
          });
          inp.addEventListener('click', function (e) { if (e.detail > 0) { open(false); btn.focus(); } });
          inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); open(false); btn.focus(); } });
        });
        dd.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !list.hidden) { open(false); btn.focus(); } });
        document.addEventListener('click', function (e) { if (!list.hidden && !dd.contains(e.target)) open(false); });
      });

      var vJson = root.querySelector('[data-cz-variants]'), idInput = root.querySelector('[data-cz-variant-id]');
      if (main && vJson && idInput) {
        var variants = JSON.parse(vJson.textContent);
        var sync = function (jump) {
          var b = root.querySelector('input[data-cz-bundle]:checked');
          var v = variants.filter(function (x) { return b && x.o1 === b.value && x.o2 === main.value; })[0];
          if (!v) return;
          idInput.value = v.id;
          root.querySelectorAll('[data-cz-atc], .cz-sticky .cz-atc').forEach(function (btn) {
            btn.disabled = !v.a;
            if (btn.hasAttribute('data-cz-atc')) btn.textContent = v.a ? 'Dodaj do koszyka' : 'Chwilowo niedostępne';
          });
          if (jump && slides && v.m) {
            var target = slides.querySelector('[data-media-id="' + v.m + '"]');
            if (target) go(Array.prototype.indexOf.call(slides.children, target));
          }
        };
        main.addEventListener('change', function () { sync(true); });
        root.querySelectorAll('input[data-cz-bundle]').forEach(function (r) { r.addEventListener('change', function () { sync(false); }); });
        sync(false);
      }
    }

    // Oś dostawy w dniach roboczych od dziś
    var tl = root.querySelector('[data-cz-timeline]');
    if (tl) {
      var add = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
      var fmt = function (d) { return d.toLocaleDateString('pl-PL', { day: 'numeric', month: 'short' }); };
      var now = new Date(), ship = add(now, Number(tl.dataset.ship));
      tl.querySelector('[data-d="0"]').textContent = fmt(now);
      tl.querySelector('[data-d="ship"]').textContent = fmt(ship);
      tl.querySelector('[data-d="end"]').textContent = fmt(add(ship, Number(tl.dataset.min))) + ' - ' + fmt(add(ship, Number(tl.dataset.max)));
    }

    // Przyklejony pasek koszyka. Pokazuje się, gdy główny przycisk zniknie u góry ekranu, a na telefonie (poniżej 750 px)
    // już po przewinięciu galerii, choć przycisk jest jeszcze niżej. Wtedy, jeśli pasek ma data-cz-label-show (karta produktu),
    // przycisk w pasku mówi „Wybierz zestaw” i przewija do wyboru zestawu zamiast od razu dodawać do koszyka.
    var atc = root.querySelector('[data-cz-atc]'), sticky = root.querySelector('[data-cz-sticky]');
    if (atc && sticky) {
      var sBtn = sticky.querySelector('.cz-atc'), sLabel = sBtn ? sBtn.textContent : '', showLabel = sticky.getAttribute('data-cz-label-show'), below = false;
      var upd = function () {
        var r = atc.getBoundingClientRect(), vh = window.innerHeight;
        var visible = r.bottom > 0 && r.top < vh;
        below = r.top >= vh;
        var on = !visible && (r.top < 0 || (window.innerWidth < 750 && window.scrollY > 360));
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (sBtn && showLabel) sBtn.textContent = below ? showLabel : sLabel;
      };
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      if (sBtn) sBtn.addEventListener('click', function (ev) {
        if (!below || !showLabel) return;
        ev.preventDefault();
        var t = root.querySelector('.cz-bundles') || root.querySelector('[data-cz-buy]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Koszyk wysuwany (18.10.2026): „Dodaj do koszyka” (także z paska przyklejonego) dodaje przez /cart/add.js i otwiera
    // koszyk z prawej (cart-drawer z Dawn, ustawienie cart_type = drawer), skąd klient idzie prosto do kasy.
    // Bez koszyka wysuwanego albo przy błędzie formularz wysyła się zwykłą drogą (strona /cart pokaże komunikat Shopify).
    var buyForm = root.querySelector('form[data-cz-buy]'), drawer = document.querySelector('cart-drawer');
    // Warunek sprawdzany przy kliknięciu: cart-drawer.js ładuje się po tym pliku, więc przy starcie element nie jest jeszcze gotowy.
    if (buyForm && drawer && window.fetch) {
      buyForm.addEventListener('submit', function (ev) {
        if (typeof drawer.renderContents !== 'function') return;
        ev.preventDefault();
        var btns = Array.prototype.slice.call(document.querySelectorAll('[data-cz-atc], .cz-sticky .cz-atc'));
        var was = btns.map(function (b) { return b.disabled; });
        btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        var restore = function () { btns.forEach(function (b, i) { b.disabled = was[i]; b.removeAttribute('aria-busy'); }); };
        var fd = new FormData(buyForm);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            restore();
            if (res.status) { buyForm.submit(); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { restore(); buyForm.submit(); });
      });
    }

    root.querySelectorAll('[data-cz-tobuy]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        root.querySelector('[data-cz-buy]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });
})();
